import React from "react";
import { Grid, TextField, Typography } from "@mui/material";
import ProfileStyles from "../../styles/userProfile.module.css";

const EmailPreferences = ({ profile }) => {
    return (
        <div>
            <Typography className={ProfileStyles.section_header}>
                Email Preferences
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        label="Newsletter Subscription"
                        value={profile?.newsletterSubscription ? "Subscribed" : "Not Subscribed"}
                        variant="outlined"
                        fullWidth
                        size="small"
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        label="Promotional Emails"
                        value={profile?.promotionalEmails ? "Enabled" : "Disabled"}
                        variant="outlined"
                        fullWidth
                        size="small"
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default EmailPreferences;